import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-batch-list',
  templateUrl: './stock-batch-list.component.html',
  styleUrls: ['./stock-batch-list.component.css']
})
export class StockBatchListComponent implements OnInit {
    stockKeyno;

    public itemsListStockBatches: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadStockBatches() {
        if (!!this.stockKeyno) {
            this.itemsListStockBatches = await this.datatask.Post(170, { stock_keyno: this.stockKeyno });
        }
    }

    private async init() {
        this.loadStockBatches();
    }

    ngOnInit() {
        this.init();
    }
}
